/* eslint-disable arrow-body-style */
export const getDfedsColors = () => [
  '#C3393E',
  '#E19415',
  '#577C32',
  '#2F6FED',
  '#2A9D8F',
  '#F46F27',
  '#1E45A7',
  '#A4812C',
  '#8A54F7',
  '#FF6EB4',
  '#277DA7',
  '#8A3324',
  '#FF9912',
  '#90BC36',
  '#DDA0DD',
  '#E26372',
  '#70AEE1',
  '#CD6600',
  '#33AD64',
  '#B732CC',
  '#7112EA',
  '#359CD7',
  '#8E8E38',
  '#BC4396',
  '#CE7853',
  '#FF937B',
  '#AB82FF',
  '#C2CA50',
  '#84CE77',
  '#B863D6',
  '#FFB6C1',
  '#5A9BD5',
  '#E78A1D',
  '#405A22',
  '#FB2D4F',
  '#6A329F',
  '#47B39C',
  '#E44236',
  '#FFCB33',
  '#B86F3A',
  '#3B88D6',
  '#67C35C',
  '#AE4377',
  '#2B5A93',
  '#F8A25C',
  '#978E66',
  '#C87DA2',
  '#FFDD67',
  '#348C75',
  '#6B98FF',
];
